import { useEffect, useId } from 'react';
import { createPortal } from 'react-dom';
import { Button } from '@/components/ui/button.jsx';

// Diálogo de confirmación accesible y acorde al branding del proyecto
export function ConfirmDialog({ open, title, description, confirmLabel, cancelLabel, tone = 'danger', onConfirm, onCancel }) {
  const titleId = useId();
  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        onCancel();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open, onCancel]);

  if (!open) {
    return null;
  }

  return createPortal(
    <>
      <div className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm" aria-hidden="true" onClick={onCancel} />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-6">
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby={titleId}
          className="w-full max-w-md rounded-3xl bg-[var(--panel)] p-8 text-[var(--text-primary)] shadow-2xl focus-visible:outline-none dark:bg-slate-900/90"
        >
          <h2 id={titleId} className="text-lg font-semibold text-[var(--text-primary)]">
            {title}
          </h2>
          <p className="mt-3 text-sm text-[var(--text-muted)]">{description}</p>
          <div className="mt-6 flex items-center justify-end gap-3">
            <Button variant="ghost" className="rounded-2xl" onClick={onCancel}>
              {cancelLabel || 'Cancelar'}
            </Button>
            <Button
              variant={tone === 'danger' ? 'danger' : 'success'}
              className="rounded-2xl"
              onClick={onConfirm}
            >
              {confirmLabel || 'Confirmar'}
            </Button>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
}

export default ConfirmDialog;
